var a={childMarginX:"NONE",childMarginY:"XS"};export{a as default};
